export default __webpack_public_path__ + "static/media/chip_5000.2658b0d0.svg";